interface ParallaxTarget { sel: string; speed: number; }

const TARGETS: ParallaxTarget[] = [
  { sel: '.s-hero__blob',       speed:  0.4 },
  { sel: '.s-hero__numbers',    speed:  0.18 },
  { sel: '.s-hero__tag',        speed: -0.12 },
  { sel: '.s-hero__corner--bl', speed: -0.08 },
  { sel: '.fx-hero-canvas',     speed:  0.22 },
];

export function setupParallax() {
  // Skip on touch devices — momentum scrolling produces inconsistent
  // velocity readings and parallax tends to feel laggy on phones.
  if (matchMedia('(pointer: coarse)').matches) return;

  const items: { el: HTMLElement; speed: number }[] = [];
  for (const t of TARGETS) {
    document.querySelectorAll<HTMLElement>(t.sel).forEach((el) => {
      el.dataset.parallax = '1';
      items.push({ el, speed: t.speed });
    });
  }

  let scrollY = 0;
  let targetY = window.scrollY;
  window.addEventListener('scroll', () => { targetY = window.scrollY; }, { passive: true });

  const marquee = document.querySelector<HTMLElement>('.s-marquee');

  const apply = () => {
    scrollY += (targetY - scrollY) * 0.15;
    for (const { el, speed } of items) {
      el.style.transform = `translate3d(0, ${-scrollY * speed}px, 0)`;
    }
    if (marquee) {
      const r = marquee.getBoundingClientRect();
      const center = r.top + r.height / 2 - window.innerHeight / 2;
      const tilt = Math.max(-3.2, Math.min(3.2, -center / 220));
      marquee.style.transform = `rotate(${tilt}deg)`;
    }
    requestAnimationFrame(apply);
  };
  apply();
}
